import { useEffect, useState } from 'react';
import { Loading, useDataProvider, useNotify } from 'react-admin';
import { useParams } from 'react-router';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import UserDetail from './UserDetail';
import { Button } from '@mui/material';
import { goApi } from '../../services';

const timeAgo = (date: string) => {
    const seconds = Math.floor((Date.now() - new Date(date).getTime()) / 1000);

    const intervals: any = {
        year: 31536000,
        month: 2592000,
        day: 86400,
        hour: 3600,
        minute: 60,
    };

    for (const key in intervals) {
        const value = Math.floor(seconds / intervals[key]);
        if (value >= 1) {
            return `about ${value} ${key}${value > 1 ? 's' : ''} ago`;
        }
    }
    return 'just now';
};

const CommentHeader = ({ createdAt, user }: any) => {
    return (
        <div className="flex gap-2 items-center">
            {/* Left: Avatar + Time */}
            <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center text-white font-semibold">
                {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
            </div>
            <div className="flex flex-col">
                <p>{user?.name}</p>
                <div className="text-sm text-gray-500">{timeAgo(createdAt)}</div>
            </div>
        </div>
    );
};

const ReplyList = ({ parentId, parentType }: any) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const [replyList, setReplyList] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const fetchReplies = async () => {
        if (!parentId || !parentType) return;

        setLoading(true);
        try {
            const res = await goApi.get(`/comments?parentId=${parentId}&parentType=${parentType}`);

            setReplyList(res?.data?.items || []);
        } catch (err) {
            notify('Error fetching replies', { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReplies();
    }, [parentId, parentType]);

    const handleDeleteReply = async (replyId: string) => {
        try {
            await goApi.delete(`/comments/${replyId}`);
            notify('Reply deleted successfully', { type: 'success' });
            fetchReplies();
        } catch (err) {
            notify('Error deleting reply', { type: 'error' });
        }
    };

    return (
        <>
            {loading ? (
                <Loading />
            ) : (
                <div className="flex flex-col gap-3 ">
                    {replyList?.map((reply: any) => (
                        <div key={reply?.id} className="bg-white p-4 border ml-16">
                            <div className="flex justify-between items-center cursor-pointer">
                                <div className="flex gap-3  w-4/6">
                                    <div className="flex gap-3 flex-col w-full ">
                                        <h3 className=" text-gray-800 w-2/3">
                                            {/* <UserDetail userId={reply?.user_id} createdAt={reply?.created_at} /> */}
                                            <CommentHeader
                                                user={reply?.user}
                                                createdAt={reply?.createdAt}
                                            />
                                        </h3>

                                        <div className="flex flex-col pl-16">
                                            <p className="text-gray-900">{reply?.content}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex gap-4 items-center">
                                    <Button
                                        color="error"
                                        className="text-red-500 text-sm  hover:font-bold"
                                        onClick={() => handleDeleteReply(reply.id)}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default ReplyList;
